import { main_phaser } from "../madnes/MadnesApp";
import { madnes_tween_func, madnes_tween_to } from "./madnes_tween";

var madnes_audio_fading = {};

export let muted = true;

let audio_decoded = false;
export const sounds = {};
let have_audio = true;

let madnes_audio_level_default = 1;
export const madnes_audio_levels = {};

export function set_muted(bool) {
	muted = bool;
}

export function set_audio_decoded(bool) {
	audio_decoded = bool;
}

export function madnes_set_default_volume(vol) {
	madnes_audio_level_default = vol;
}

export function madnes_set_audio_volume(key, value) {
	madnes_audio_levels[key] = value;
}

export function madnes_get_audio_level_volume(name) {
	if (typeof madnes_audio_levels[name] !== "undefined") {
		return madnes_audio_levels[name];
	}

	return madnes_audio_level_default;
}

export function madnes_audio_allow_multiple(name) {
	if (have_audio && sounds[name] != null) {
		sounds[name].allowMultiple = true;
	}
}

export function madnes_audio_deny_multiple(name) {
	if (have_audio && sounds[name] != null) {
		sounds[name].allowMultiple = false;
	}
}

export function madnes_audio_play(name) {
	if (have_audio && sounds[name] != null) {
		sounds[name].loop = false;

		var volume = madnes_get_audio_level_volume(name);

		if (/*muted == 1 ||*/ !audio_decoded) {
			volume = 0;
		}

		sounds[name].volume = volume;

		// console.log('playing', name, volume);

		sounds[name].play();
	}
}

export function madnes_audio_pause(name) {
	if (have_audio && sounds[name] != null) {
		sounds[name].pause();
	}
}

/**
 * @param {string} name
 * @param {number=} vol
 */
export function madnes_audio_loop(name, vol) {
	if (!have_audio) return;

	var volume = vol !== undefined ? vol : madnes_get_audio_level_volume(name);

	if (/*muted ||*/ !audio_decoded) {
		volume = 0;
	}

	if (sounds[name] != null) {
		sounds[name].loop = true;
		sounds[name].volume = volume;
		sounds[name].play();
	}
}

export function madnes_add_audio_to_sounds(audio_name) {
	sounds[audio_name] = main_phaser.add.audio(audio_name);
}

/**
 * @param {string|Array} files containing key strings of audio files found in Phaser.Cache
 * @param {Function=} callback - The callback which will be invoked once all files have finished decoding.
 */
export function madnes_audio_ready(files, callback) {
	if (typeof files === "string") {
		files = [files];
	}

	if (files.length === 0) {
		callback();
		return true;
	} else {
		for (var i = 0; i < files.length; i++) {
			if (main_phaser.cache.isSoundReady(files[i])) {
				files.splice(i, 1);
			}
		}

		setTimeout(madnes_audio_ready.bind(this, files, callback), 100);
	}
}

export function madnes_audio_stop(name) {
	if (have_audio && sounds[name] != null) {
		sounds[name].stop();
	}
}

export function madnes_audio_continue(name) {
	if (have_audio && sounds[name] != null) {
		if (sounds[name].paused) {
			sounds[name].resume();
		}
	}
}

export function madnes_audio_add_once_onstop(name, func) {
	sounds[name].onStop.addOnce(func);
}

export function madnes_audio_is_playing(name) {
	if (madnes_audio_is_suspend()) {
		return false;
	}

	if (have_audio && sounds[name] != null) {
		return sounds[name].isPlaying;
	}
	return false;
}

export function madnes_audio_is_paused(name) {
	if (have_audio && sounds[name] != null) {
		return sounds[name].paused;
	}
}

export function madnes_audio_onstop(name, func) {
	if (have_audio && sounds[name] != null) {
		sounds[name].onStop.add(func);
	}
}

export function madnes_audio_is_suspend() {
	return (
		main_phaser &&
		main_phaser["sound"]["context"] &&
		main_phaser["sound"]["context"]["state"] === "suspended"
	);
}

/**
 * @param {string} name
 * @param {number} duration
 * @param {boolean=} stop
 * @param {Function=} callback
 */
export function madnes_audio_fade_out(name, duration, stop, callback, ease) {
	if (typeof stop === "undefined") {
		stop = true;
	}
	if (typeof callback === "undefined") {
		callback = function () {};
	}

	madnes_audio_fade_to(
		name,
		0,
		duration,
		function () {
			stop && madnes_audio_stop(name);
			callback();
		},
		"equal_power_in"
	);
}

/**
 * @param {string} name
 * @param {number} duration
 * @param {Function=} callback
 */
export function madnes_audio_fade_in(name, duration, callback) {
	if (typeof callback === "undefined") {
		callback = function () {};
	}

	var volume = madnes_get_audio_level_volume(name);

	madnes_audio_set_volume(name, 0);
	madnes_audio_fade_to(name, volume, duration, callback, "equal_power_öut");
}

/**
 * @param {string} name
 * @param {number} to
 * @param {number} time
 * @param {Function=} callback
 * @param {string=} ease
 */
export function madnes_audio_fade_to(name, to, time, callback, ease) {
	if (!have_audio) {
		callback && setTimeout(callback, time ? time : 0);
		return;
	}

	if (typeof madnes_audio_fading[name] !== "undefined") {
		madnes_audio_fading[name].stop();
	}

	if (typeof time === "undefined") {
		time = 1000;
	}
	if (typeof callback === "undefined") {
		callback = function () {};
	}

	var obj = { volume: sounds[name]["volume"] };

	madnes_audio_fading[name] = madnes_tween_to(
		obj,
		{ volume: to },
		{
			duration: time,
			update: function () {
				madnes_audio_fade_to_update(name, obj["volume"]);
			},
			callback: function () {
				madnes_audio_fade_to_update(name, to);
				delete madnes_audio_fading[name];
				callback();
			},
			easing: ease ? madnes_tween_func(ease) : undefined,
		}
	);
}

export function madnes_audio_fade_to_update(name, vol) {
	if (have_audio && /*muted == 0 &&*/ audio_decoded) {
		sounds[name]["volume"] = vol;
	}
}

export function madnes_audio_set_volume(name, vol) {
	if (have_audio && typeof sounds[name].volume !== "undefined") {
		return (sounds[name].volume = vol);
	}
}

export function madnes_audio_get_volume(name) {
	if (have_audio && typeof sounds[name].volume !== "undefined") {
		return sounds[name].volume;
	}
}

export function madnes_fade_in_game_sounds() {
	for (let name in sounds) {
		// sounds[name].volume = 0;
		//
		//
		// let volume = madnes_get_audio_level_volume(name);
		//
		// madnes_audio_fade_to(name, volume, 1000, () => {
		//
		//     if(name === "BACKGROUND") {
		//         madnes_audio_loop(name);
		//     }
		//
		//
		// });
	}

	// madnes_cstm_functions['on_fade_in_audio'] && madnes_cstm_functions['on_fade_in_audio']();
}
